function getStatisticFilterStorageKey() {
  const locationMatch = window.location.pathname.match(/\/location\/(\d+)/);
  return `statistic-filters-${locationMatch ? locationMatch[1] : 'default'}`;
}

function getSavedStatisticFilters() {
  try {
    return JSON.parse(sessionStorage.getItem(getStatisticFilterStorageKey())) || {};
  } catch (error) {
    return {};
  }
}

function restoreStatisticFilters() {
  const savedFilters = getSavedStatisticFilters().form || {};
  Object.keys(savedFilters).forEach(function (name) {
    const field = $(`[name="${name}"]`);
    if (!field.length) {
      return;
    }

    if (field.is(':checkbox, :radio')) {
      field.prop('checked', false).each(function () {
        $(this).prop('checked', savedFilters[name].includes($(this).val()));
      });
    } else if (field.is('select[multiple]') || field.length > 1) {
      field.val(savedFilters[name]);
    } else {
      field.val(savedFilters[name][0]);
    }
  });
}

function saveStatisticFilters(scope) {
  const formValues = {};
  $('#event-statistic-form :input[name]').each(function () {
    const field = $(this);
    const name = field.attr('name');
    if (Object.prototype.hasOwnProperty.call(formValues, name)) {
      return;
    }

    if (field.is(':checkbox, :radio')) {
      formValues[name] = $(`[name="${name}"]:checked`)
        .map(function () {
          return $(this).val();
        })
        .get();
    } else {
      const value = field.val();
      formValues[name] = Array.isArray(value) ? value : [value];
    }
  });

  const savedFilters = getSavedStatisticFilters();
  savedFilters.form = formValues;
  if (scope) {
    savedFilters.scope = scope;
  }
  try {
    sessionStorage.setItem(
      getStatisticFilterStorageKey(),
      JSON.stringify(savedFilters)
    );
  } catch (error) {
    // Statistics still work when browser storage is unavailable.
  }
}

function getDefaultStatisticScope() {
  const selectedLocations = $('#location-id').val() || ['all'];
  return selectedLocations.includes('all')
    ? ['all']
    : selectedLocations.map((location) => `location:${location}`);
}

function getSelectedStatisticScope(tree) {
  return tree
    .get_selected(true)
    .map((node) => node.li_attr['data-scope'])
    .filter(Boolean);
}

function getAvailableStatisticScope() {
  return $('#statistic-location-tree [data-scope]')
    .map(function () {
      return $(this).attr('data-scope');
    })
    .get();
}

function normalizeStatisticScope(scope, availableScope) {
  const requestedScope = Array.isArray(scope) ? scope : [];
  const validScope = [...new Set(requestedScope)].filter((item) =>
    availableScope.includes(item)
  );
  if (validScope.includes('all')) {
    return ['all'];
  }
  return validScope.length ? validScope : ['all'];
}

function getStatisticScope() {
  const locationTree = $('#statistic-location-tree');
  const savedScope = getSavedStatisticFilters().scope;
  const requestedScope = Array.isArray(savedScope)
    ? savedScope
    : getDefaultStatisticScope();
  const fallbackScope = locationTree.length
    ? normalizeStatisticScope(requestedScope, getAvailableStatisticScope())
    : ['all'];
  const tree =
    locationTree.length && $.fn.jstree ? locationTree.jstree(true) : null;
  if (tree) {
    const selectedScope = getSelectedStatisticScope(tree);
    return selectedScope.length ? selectedScope : fallbackScope;
  }

  return locationTree.length ? fallbackScope : ['all'];
}

restoreStatisticFilters();

let p = $('body').attr('p');
let a = $('body').attr('a');
let filterBy = $('body').attr('filter_by') || null;
let startDateQuery = $('body').attr('start_date')?.replace('T', ' ') || null;
let endDateQuery = $('body').attr('end_date')?.replace('T', ' ') || null;
let customPeriodQuery = $('body').attr('custom_period') || 'null';
let prevSelectedPeriodQuery = $('body').attr('prev_selected_period') || null;
let locationId = $('#location-id').val();
let startDate = $('#start-date').val();
let endDate = $('#end-date').val();
let period = 'day';
let supplierId = $('#supplier-id').val();
let productGroupUniqueId = $('#product-group-id').val();
let topProductGroupUniqueId = $('#top-product-group-id').val();
let selectedDay = $('#custom-day').val();
let chartComponent = null;
let userId = $('#user-id').val();
let platform = $('#platform').val() || 'all';
let prevSelectedPeriod = 'day';
let isDateChanged = false;
let durationOfstartAndEndDate = 0;
let durationOfstartAndEndDateByMonths = 0;
let customPeriod = '';
let isMobile = false;
let isTablet = false;
let isDesktop = false;
var deviceWidth = $(window).width();
let customerId = $('#customer-id').val() || 0;
let compareBy = $('#compare').val() || null;
compareBy = compareBy === '0' ? null : compareBy;
let productId = $('#product-id').val();
let productCategoryId = $('#product-category-id').val();
let vatCode = $('#vat-code').val();
let paymentMethod = $('#payment-method').val();
let crossesMidnight = false;

$('.selectpicker').selectpicker({
  countSelectedText: function (numSelected, numTotal) {
    return numSelected + ' ' + 'moduler';
  },
});

$.ajaxPrefilter(function (options) {
  if (!options.url || !options.url.includes('/ajax/statistic_')) {
    return;
  }

  const scopeData = $.param({ statisticsScope: getStatisticScope() });
  if (typeof options.data === 'string') {
    options.data = options.data ? `${options.data}&${scopeData}` : scopeData;
  } else {
    options.data = $.extend({}, options.data, {
      statisticsScope: getStatisticScope(),
    });
  }
});

// Store previous selections for each selector
const previousSelections = new Map();
$('#filter')
  .on('show.bs.collapse', function () {
    $('#filter-collapse-container').removeClass('p-0');
  })
  .on('hide.bs.collapse', function () {
    $('#filter-collapse-container').addClass('p-0');
  });

function handleSelectedOptions(targetSelector) {
  const currentSelection = targetSelector.val() || [];
  const allValue = 'all';
  const selectorId = targetSelector.attr('id');

  // Get previous selection for this selector
  const previousSelection = previousSelections.get(selectorId) || [];

  // If nothing is selected, default to "all"
  if (currentSelection.length === 0) {
    targetSelector.selectpicker('val', [allValue]).selectpicker('refresh');
    previousSelections.set(selectorId, [allValue]);
    return;
  }

  // Check current state
  const allSelected = currentSelection.includes(allValue);
  const otherOptionsSelected = currentSelection.filter(
    (option) => option !== allValue
  );
  const wasAllPreviouslySelected = previousSelection.includes(allValue);

  if (allSelected && otherOptionsSelected.length > 0) {
    // Both "all" and others are selected - determine what user intended
    if (wasAllPreviouslySelected) {
      // State 1: "All" was selected, user added other options
      // Remove "all" and keep only the other selections
      targetSelector
        .selectpicker('val', otherOptionsSelected)
        .selectpicker('refresh');
      previousSelections.set(selectorId, otherOptionsSelected);
    } else {
      // State 2: Other options were selected, user clicked "All"
      // Remove everything else and keep only "all"
      targetSelector.selectpicker('val', [allValue]).selectpicker('refresh');
      previousSelections.set(selectorId, [allValue]);
    }
  } else {
    // Normal case: either only "all" or only other options are selected
    previousSelections.set(selectorId, currentSelection);
  }
}

function setDateAndPeriod(
  startDateFromQuery,
  endDateFromQuery,
  filterByFromQuery,
  customPeriodFromQuery,
  prevSelectedPeriodFromQuery
) {
  if (startDateFromQuery) {
    startDate = startDateFromQuery;
  }
  if (endDateFromQuery) {
    endDate = endDateFromQuery;
  }
  if (filterByFromQuery) {
    filterBy = filterByFromQuery;
  }
  if (customPeriodFromQuery) {
    customPeriod = customPeriodFromQuery;
  }
  if (prevSelectedPeriodFromQuery) {
    prevSelectedPeriod = prevSelectedPeriodFromQuery;
  }
}

if (deviceWidth < 768) {
  isMobile = true;
} else if (deviceWidth >= 768 && deviceWidth < 992) {
  isTablet = true;
} else {
  isDesktop = true;
}

function dateAndPeriodValidation(startedDate, endedDate) {
  let start = moment(startedDate);
  let end = moment(endedDate);
  durationOfstartAndEndDateByMonths = moment(endedDate.split(' ')[0]).diff(
    startedDate.split(' ')[0],
    'months'
  );

  if (start.isAfter(end)) {
    $('#start-date').val(startDate);
    $('#end-date').val(endDate);
    return alert('end date cannot be later than start date');
  } else if (durationOfstartAndEndDateByMonths > 36) {
    $('#start-date').val(startDate);
    $('#end-date').val(endDate);
    return alert('Maksimal varighet er 3 år');
  } else {
    return true;
  }
}

if (filterBy) {
  $('.period-button').removeClass('active');
  let periodTitleOfFilterBy = '';
  prevSelectedPeriod = prevSelectedPeriodQuery
    ? prevSelectedPeriodQuery
    : prevSelectedPeriod;
  $('.period-button').removeClass('active');

  $('#compare').prop('disabled', false);

  if (filterBy === 'week') {
    $('#period-week').addClass('active');
    period = 'week';
    prevSelectedPeriod = 'week';
    customPeriod = customPeriodQuery ? customPeriodQuery : 'day';
    startDate = startDateQuery
      ? startDateQuery
      : moment().startOf('week').format('YYYY-MM-DD') + ' 00:00';
    endDate = endDateQuery
      ? endDateQuery
      : moment().endOf('week').format('YYYY-MM-DD') + ' 23:59';
    periodTitleOfFilterBy = 'Uke nr' + ' ' + moment(startDate).isoWeek();
  } else if (filterBy === 'day') {
    $('#period-day').addClass('active');
    customPeriod = customPeriodQuery ? customPeriodQuery : 'time';
    startDate = startDateQuery
      ? startDateQuery
      : moment().startOf('week').format('YYYY-MM-DD') + ' 00:00';
    endDate = endDateQuery
      ? endDateQuery
      : moment().endOf('week').format('YYYY-MM-DD') + ' 23:59';
    $(`#custom-period option[value="time"]`).prop('selected', true);

    periodTitleOfFilterBy = dayFormatAbbreviation(
      moment(startDate).format('ddd - DD.MM.YYYY')
    );
  } else if (filterBy === 'month') {
    $('#period-month').addClass('active');
    period = 'month';
    prevSelectedPeriod = 'month';
    startDate = startDateQuery
      ? startDateQuery
      : moment().startOf('week').format('YYYY-MM-DD') + ' 00:00';
    endDate = endDateQuery
      ? endDateQuery
      : moment().endOf('week').format('YYYY-MM-DD') + ' 23:59';
    if (isDesktop) {
      customPeriod = 'day';
      $(`#custom-period option[value="time"]`).prop('selected', false);
      $(`#custom-period option[value="day"]`).prop('selected', true);
    } else {
      customPeriod = 'week';
      $(`#custom-period option[value="day"]`).prop('selected', false);
      $(`#custom-period option[value="week"]`).prop('selected', true);
      $(`#custom-period option[value="day"]`).prop('disabled', true);
    }
    periodTitleOfFilterBy = moment(startDate).format('MMMM');
  } else if (filterBy === 'year') {
    $('#period-year').addClass('active');
    period = 'year';
    prevSelectedPeriod = 'year';
    startDate = startDateQuery
      ? startDateQuery
      : moment().startOf('year').format('YYYY-MM-DD') + ' 00:00';
    endDate = endDateQuery
      ? endDateQuery
      : moment().endOf('year').format('YYYY-MM-DD') + ' 23:59';
    durationOfstartAndEndDate = 365;
    displayGraphDynamically(durationOfstartAndEndDate);
    customPeriod = 'month';
    $(`#custom-period option[value="time"]`).prop('selected', false);
    $(`#custom-period option[value="month"]`).prop('selected', true);
    periodTitleOfFilterBy = moment(startDate).format('YYYY');
    $('#compare').prop('disabled', true);
  } else {
    period = 'custom';
    customPeriod = customPeriodQuery ? customPeriodQuery : customPeriod;
    prevSelectedPeriod = prevSelectedPeriodQuery
      ? prevSelectedPeriodQuery
      : prevSelectedPeriod;
    startDate = startDateQuery;
    endDate = endDateQuery;

    $(`#period-custom`).addClass('active');
    $(`#custom-period option`).prop('selected', false);
    $(`#custom-period option[value="${customPeriod}"]`).prop('selected', false);
    $('#custom-period').val(customPeriod).trigger('change');
    if (customPeriod == 'day') {
      $('.custom-day-container').removeClass('d-none');
    } else {
      $('.custom-day-container').addClass('d-none');
    }
    $('#start-date').val(startDate);
    $('#end-date').val(endDate);

    if (prevSelectedPeriod === 'day') {
      periodTitleOfFilterBy = dayFormatAbbreviation(
        moment(startDate).format('ddd - DD.MM.YYYY')
      );
      if (startDate.split(' ')[0] == endDate.split(' ')[0]) {
        customPeriod = 'time';
        $("#custom-period option[value='time']").prop('selected', true);
        $('#custom-period').prop('disabled', true);
        $('#custom-period').val('time').trigger('change');
      } else {
        $("#custom-period option[value='time']").addClass('disabledOption');
        $("#custom-period option[value='time']").prop('disabled', true);
      }
    } else if (prevSelectedPeriod === 'week') {
      periodTitleOfFilterBy = 'Uke nr' + ' ' + moment(startDate).isoWeek();
    } else if (prevSelectedPeriod === 'month') {
      periodTitleOfFilterBy = moment(startDate).format('MMMM');
    } else {
      if (startDate.split(' ')[0] == endDate.split(' ')[0]) {
        customPeriod = 'time';
        $("#custom-period option[value='time']").prop('selected', true);
        $('#custom-period').prop('disabled', true);
        $('#custom-period').val('time').trigger('change');
      } else {
        $("#custom-period option[value='time']").addClass('disabledOption');
        $("#custom-period option[value='time']").prop('disabled', true);
      }

      periodTitleOfFilterBy =
        moment(startDate).format('DD-MM-YYYY') +
        ' : ' +
        moment(endDate).format('DD-MM-YYYY');
    }
  }
  setTimeout(() => $('#period-title').text(periodTitleOfFilterBy), 50);
} else {
  $('#period-day').prop('checked', true);
}

function handlePeriodChange(callback) {
  $(document).on('click', '.period-button', function (e) {
    $('.period-button').removeClass('active');
    $(this).addClass('active');
    period = $(this).attr('data-value');
    prevSelectedPeriod = period !== 'custom' ? period : prevSelectedPeriod;

    $('#compare').prop('disabled', false);
    if (period === 'day') {
      startDate = moment().format('YYYY-MM-DD') + ' 00:00';
      endDate = moment().format('YYYY-MM-DD') + ' 23:59';
      const currentDayFormatted = moment().format('ddd - DD.MM.YYYY');
      customPeriod = 'time';
      $('#period-title').text(dayFormatAbbreviation(currentDayFormatted));
      if (compareBy && compareBy !== '0') {
        compareBy = 'day-compare';
        $('#compare').val('day-compare').trigger('change.select2');
      }
    } else if (period === 'week') {
      startDate = moment().startOf('week').format('YYYY-MM-DD') + ' 00:00';
      endDate = moment().endOf('week').format('YYYY-MM-DD') + ' 23:59';
      const currentWeekNumber = moment().utc().isoWeek();
      customPeriod = 'day';
      $(`#custom-period option[value="day"]`).prop('selected', true);
      $('#period-title').text('Uke nr' + ' ' + currentWeekNumber);
      if (compareBy && compareBy !== '0') {
        compareBy = 'week-compare';
        $('#compare').val('week-compare').trigger('change.select2');
      }
    } else if (period === 'month') {
      startDate = moment().startOf('month').format('YYYY-MM-DD') + ' 00:00';
      endDate = moment().endOf('month').format('YYYY-MM-DD') + ' 23:59';
      durationOfstartAndEndDate = 30;
      displayGraphDynamically(durationOfstartAndEndDate);
      if (isDesktop) {
        customPeriod = 'day';
        $(`#custom-period option[value="time"]`).prop('selected', false);
        $(`#custom-period option[value="day"]`).prop('selected', true);
      } else {
        customPeriod = 'week';
        $(`#custom-period option[value="day"]`).prop('selected', false);
        $(`#custom-period option[value="week"]`).prop('selected', true);
        $(`#custom-period option[value="day"]`).prop('disabled', true);
      }
      const currentMonth = moment().format('MMMM');
      $('#period-title').text(currentMonth);
      if (compareBy && compareBy !== '0') {
        compareBy = 'month-compare';
        $('#compare').val('month-compare').trigger('change.select2');
      }
    } else if (period === 'year') {
      startDate = moment().startOf('year').format('YYYY-MM-DD') + ' 00:00';
      endDate = moment().endOf('year').format('YYYY-MM-DD') + ' 23:59';
      durationOfstartAndEndDate = 365;
      compareBy = null;
      displayGraphDynamically(durationOfstartAndEndDate);
      customPeriod = 'month';

      $(`#custom-period option[value="time"]`).prop('selected', false);
      $(`#custom-period option[value="month"]`).prop('selected', true);
      $('#period-title').text(moment().format('YYYY'));

      $('#compare').prop('disabled', true);
    } else {
      $('#period-title').text('Custom');
      $('#compare').val('0').trigger('change.select2');
      compareBy = null;
      if (startDate.split(' ')[0] == endDate.split(' ')[0]) {
        customPeriod = 'time';
        $("#custom-period option[value='time']").prop('selected', true);
        $('#custom-period').prop('disabled', true);
        $('#custom-period').val('time').trigger('change');
      } else {
        $("#custom-period option[value='time']").prop('disabled', true);
        $('#custom-period').prop('disabled', false);
      }
    }
    $('#start-date').val(startDate);
    $('#end-date').val(endDate);
    toggleCustomDatePicker();
    if (customPeriod == 'day') {
      $('.custom-day-container').removeClass('d-none');
    } else {
      if (!$('.custom-day-container').hasClass('d-none')) {
        $('.custom-day-container').addClass('d-none');
      }
    }
    callback(
      startDate,
      endDate,
      period,
      supplierId,
      productGroupUniqueId,
      locationId,
      userId,
      platform,
      customPeriod,
      topProductGroupUniqueId,
      customerId,
      compareBy,
      productId,
      vatCode,
      paymentMethod,
      productCategoryId
    );
  });
}

function handleCustomerIdChange(callback) {
  $(document).on('change', '#customer-id', function (e) {
    e.preventDefault();
    handleSelectedOptions($(this));
    customerId = $(this).val();
    callback(
      startDate,
      endDate,
      period,
      supplierId,
      productGroupUniqueId,
      locationId,
      userId,
      platform,
      customPeriod,
      topProductGroupUniqueId,
      customerId,
      compareBy,
      productId,
      vatCode,
      paymentMethod,
      productCategoryId
    );
  });
}

function handleCustomPeriodChange(callback) {
  $(document).on('change', '#custom-period', function (e) {
    e.preventDefault();
    customPeriod = $(this).val();
    if (customPeriod == 'day') {
      $('.custom-day-container').removeClass('d-none');
    } else {
      if (!$('.custom-day-container').hasClass('d-none')) {
        $('.custom-day-container').addClass('d-none');
      }
    }
    callback(
      startDate,
      endDate,
      period,
      supplierId,
      productGroupUniqueId,
      locationId,
      userId,
      platform,
      customPeriod,
      topProductGroupUniqueId,
      customerId,
      compareBy,
      productId,
      vatCode,
      paymentMethod,
      productCategoryId,
      selectedDay
    );
  });
}

function handleTopProductGroupChange(callback) {
  $(document).on('change', '#top-product-group-id', function (e) {
    e.preventDefault();
    handleSelectedOptions($(this));

    $('#product-group-id').selectpicker('val', ['all']).selectpicker('refresh');

    topProductGroupUniqueId = $(this).val();
    callback(
      startDate,
      endDate,
      period,
      supplierId,
      productGroupUniqueId,
      locationId,
      userId,
      platform,
      customPeriod,
      topProductGroupUniqueId,
      customerId,
      compareBy,
      productId,
      vatCode,
      paymentMethod,
      productCategoryId
    );
  });
}

function handleProductGroupChange(callback) {
  $(document).on('change', '#product-group-id', function (e) {
    e.preventDefault();
    handleSelectedOptions($(this));

    $('#top-product-group-id')
      .selectpicker('val', ['all'])
      .selectpicker('refresh');

    productGroupUniqueId = $(this).val();
    callback(
      startDate,
      endDate,
      period,
      supplierId,
      productGroupUniqueId,
      locationId,
      userId,
      platform,
      customPeriod,
      topProductGroupUniqueId,
      customerId,
      compareBy,
      productId,
      vatCode,
      paymentMethod,
      productCategoryId
    );
  });
}

function handleProductChange(callback) {
  $(document).on('change', '#product-id', function (e) {
    e.preventDefault();
    handleSelectedOptions($(this));
    productId = $(this).val();
    callback(
      startDate,
      endDate,
      period,
      supplierId,
      productGroupUniqueId,
      locationId,
      userId,
      platform,
      customPeriod,
      topProductGroupUniqueId,
      customerId,
      compareBy,
      productId,
      vatCode,
      paymentMethod,
      productCategoryId
    );
  });
}

function handleProductCategoryChange(callback) {
  $(document).on('change', '#product-category-id', function (e) {
    e.preventDefault();
    handleSelectedOptions($(this));
    productCategoryId = $(this).val();
    callback(
      startDate,
      endDate,
      period,
      supplierId,
      productGroupUniqueId,
      locationId,
      userId,
      platform,
      customPeriod,
      topProductGroupUniqueId,
      customerId,
      compareBy,
      productId,
      vatCode,
      paymentMethod,
      productCategoryId
    );
  });
}

function handleSupplierIdChange(callback) {
  $(document).on('change', '#supplier-id', function (e) {
    e.preventDefault();
    handleSelectedOptions($(this));
    supplierId = $(this).val();
    callback(
      startDate,
      endDate,
      period,
      supplierId,
      productGroupUniqueId,
      locationId,
      userId,
      platform,
      customPeriod,
      topProductGroupUniqueId,
      customerId,
      compareBy,
      productId,
      vatCode,
      paymentMethod,
      productCategoryId
    );
  });
}

function handleUserChange(callback) {
  $(document).on('change', '#user-id', function (e) {
    e.preventDefault();
    handleSelectedOptions($(this));
    userId = $(this).val();
    callback(
      startDate,
      endDate,
      period,
      supplierId,
      productGroupUniqueId,
      locationId,
      userId,
      platform,
      customPeriod,
      topProductGroupUniqueId,
      customerId,
      compareBy,
      productId,
      vatCode,
      paymentMethod,
      productCategoryId
    );
  });
}

function handlePaymentChange(callback) {
  $(document).on('change', '#payment-method', function (e) {
    e.preventDefault();
    handleSelectedOptions($(this));
    paymentMethod = $(this).val();
    callback(
      startDate,
      endDate,
      period,
      supplierId,
      productGroupUniqueId,
      locationId,
      userId,
      platform,
      customPeriod,
      topProductGroupUniqueId,
      customerId,
      compareBy,
      productId,
      vatCode,
      paymentMethod,
      productCategoryId
    );
  });
}

function handleLocationChange(callback) {
  $(document).on('change', '#location-id', function (e) {
    e.preventDefault();
    handleSelectedOptions($(this));
    locationId = $(this).val();
    callback(
      startDate,
      endDate,
      period,
      supplierId,
      productGroupUniqueId,
      locationId,
      userId,
      platform,
      customPeriod,
      topProductGroupUniqueId,
      customerId,
      compareBy,
      productId,
      vatCode,
      paymentMethod,
      productCategoryId
    );
  });
}

function handleCustomDayChange(callback) {
  $(document).on('change', '#custom-day', function (e) {
    e.preventDefault();
    selectedDay = $(this).val();
    callback(
      startDate,
      endDate,
      period,
      supplierId,
      productGroupUniqueId,
      locationId,
      userId,
      platform,
      customPeriod,
      topProductGroupUniqueId,
      customerId,
      compareBy,
      productId,
      vatCode,
      paymentMethod,
      productCategoryId,
      selectedDay
    );
  });
}
function handleVatCodeChange(callback) {
  $(document).on('change', '#vat-code', function (e) {
    e.preventDefault();
    handleSelectedOptions($(this));
    vatCode = $(this).val();
    callback(
      startDate,
      endDate,
      period,
      supplierId,
      productGroupUniqueId,
      locationId,
      userId,
      platform,
      customPeriod,
      topProductGroupUniqueId,
      customerId,
      compareBy,
      productId,
      vatCode,
      paymentMethod,
      productCategoryId
    );
  });
}

function handlePlatformChange(callback) {
  $(document).on('change', '#platform', function (e) {
    e.preventDefault();
    platform = $(this).val();

    if (platform === 'self-service') {
      userId = 0;
      $('#user-id').val(userId);
      $('#user-id').prop('disabled', true);
    } else {
      $('#user-id').prop('disabled', false);
    }
    callback(
      startDate,
      endDate,
      period,
      supplierId,
      productGroupUniqueId,
      locationId,
      userId,
      platform,
      customPeriod,
      topProductGroupUniqueId,
      customerId,
      compareBy,
      productId,
      vatCode,
      paymentMethod,
      productCategoryId
    );
  });
}

function handleEndDateChange(callback) {
  let currentendDate = $('#end-date').val();
  if (dateAndPeriodValidation(startDate, currentendDate)) {
    isDateChanged = true;
    endDate = currentendDate;
    if (startDate.split(' ')[0] == endDate.split(' ')[0]) {
      $("#custom-period option[value='time']").prop('selected', true);
      $('#custom-period').prop('disabled', true);
      customPeriod = 'time';
    } else {
      durationOfstartAndEndDate = moment(endDate).diff(
        moment(startDate.split(' ')[0]),
        'days'
      );

      displayGraphDynamically(durationOfstartAndEndDate);

      $('#custom-period').prop('disabled', false);
    }

    callback(
      startDate,
      endDate,
      period,
      supplierId,
      productGroupUniqueId,
      locationId,
      userId,
      platform,
      customPeriod,
      topProductGroupUniqueId,
      customerId,
      compareBy,
      productId,
      vatCode,
      paymentMethod,
      productCategoryId
    );
    prevSelectedPeriod = 'custom';
    $('#period-title').text(
      moment(startDate).format('DD-MM-YYYY') +
        ' : ' +
        moment(endDate).format('DD-MM-YYYY')
    );
  }
}

function handleStartDateChange(callback) {
  let choosenDate = $('#start-date').val();

  if (dateAndPeriodValidation(choosenDate, endDate)) {
    startDate = choosenDate;
    isDateChanged = true;

    if (startDate.split(' ')[0] == endDate.split(' ')[0]) {
      $("#custom-period option[value='time']").prop('selected', true);
      $('#custom-period').prop('disabled', true);
      customPeriod = 'time';
    } else {
      durationOfstartAndEndDate = moment(endDate.split(' ')[0]).diff(
        moment(startDate),
        'days'
      );

      displayGraphDynamically(durationOfstartAndEndDate);
      $('#custom-period').prop('disabled', false);
    }
    callback(
      startDate,
      endDate,
      period,
      supplierId,
      productGroupUniqueId,
      locationId,
      userId,
      platform,
      customPeriod,
      topProductGroupUniqueId,
      customerId,
      compareBy,
      productId,
      vatCode,
      paymentMethod,
      productCategoryId
    );
    prevSelectedPeriod = 'custom';
    $('#period-title').text(
      moment(startDate).format('DD-MM-YYYY') +
        ' : ' +
        moment(endDate).format('DD-MM-YYYY')
    );
  }
}

function handlePreviousButton(callback) {
  $(document).on('click', '#previous-button', function (e) {
    e.preventDefault();
    let periodTitle = '';
    if (
      period === 'day' ||
      (prevSelectedPeriod === 'day' && !isDateChanged && period === 'custom')
    ) {
      startDate =
        moment(startDate).subtract(1, 'day').format('YYYY-MM-DD') + ' 00:00';
      endDate =
        moment(endDate).subtract(1, 'day').format('YYYY-MM-DD') + ' 23:59';
      periodTitle = dayFormatAbbreviation(
        moment(startDate).format('ddd - DD.MM.YYYY')
      );
    }
    if (
      period === 'week' ||
      (prevSelectedPeriod === 'week' && !isDateChanged && period === 'custom')
    ) {
      startDate =
        moment(startDate).subtract(1, 'week').format('YYYY-MM-DD') + ' 00:00';
      endDate =
        moment(endDate).subtract(1, 'week').format('YYYY-MM-DD') + ' 23:59';
      const currentWeekNumber = moment(startDate).isoWeek();
      periodTitle = 'Uke nr' + ' ' + currentWeekNumber;
    }

    if (
      period === 'month' ||
      (prevSelectedPeriod === 'month' && !isDateChanged && period === 'custom')
    ) {
      startDate =
        moment(startDate).subtract(1, 'month').format('YYYY-MM-DD') + ' 00:00';
      endDate =
        period === 'month'
          ? moment(endDate)
              .subtract(1, 'month')
              .endOf('month')
              .format('YYYY-MM-DD') + ' 23:59'
          : moment(endDate).subtract(1, 'month').format('YYYY-MM-DD') +
            ' 23:59';
      periodTitle = moment(startDate).format('MMMM');
    }

    if (
      period === 'year' ||
      (prevSelectedPeriod === 'year' && !isDateChanged && period === 'custom')
    ) {
      startDate =
        moment(startDate).subtract(1, 'year').format('YYYY-MM-DD') + ' 00:00';
      endDate =
        moment(endDate).subtract(1, 'year').format('YYYY-MM-DD') + ' 23:59';
      periodTitle = moment(startDate).format('YYYY');
    }

    if (period === 'custom' && prevSelectedPeriod === 'custom') {
      let previousStartDate = moment(startDate);
      let previousEndDate = moment(endDate);

      endDate =
        moment(startDate).subtract(1, 'day').format('YYYY-MM-DD') + ' 23:59';

      durationOfstartAndEndDate = previousEndDate.diff(
        previousStartDate,
        'days'
      );

      startDate =
        moment(endDate)
          .subtract(durationOfstartAndEndDate, 'days')
          .format('YYYY-MM-DD') + ' 00:00';
      periodTitle =
        moment(startDate).format('DD-MM-YYYY') +
        ' : ' +
        moment(endDate).format('DD-MM-YYYY');
    }
    $('#start-date').val(startDate);
    $('#end-date').val(endDate);
    $('#period-title').text(periodTitle);

    callback(
      startDate,
      endDate,
      period,
      supplierId,
      productGroupUniqueId,
      locationId,
      userId,
      platform,
      customPeriod,
      topProductGroupUniqueId,
      customerId,
      compareBy,
      productId,
      vatCode,
      paymentMethod,
      productCategoryId
    );
    if (compareBy && compareBy == 'day-compare') {
      let $compare = $('#compare');
      let dayCompareOption = $compare.find("option[value='day-compare']");

      if (dayCompareOption.length) {
        dayCompareOption.text(
          `i dag / forrige ${getPeriodTranslation(compareBy, startDate)}`
        );
        $compare.val('day-compare');
        $compare.trigger('change.select2');
        $compare.select2('destroy');
        $compare.select2({ theme: 'bootstrap4' });
      }
    }
  });
}

function handleNextButton(callback) {
  $(document).on('click', '#next-button', function (e) {
    e.preventDefault();
    let periodTitle = '';
    if (
      period === 'day' ||
      (prevSelectedPeriod === 'day' && !isDateChanged && period === 'custom')
    ) {
      startDate =
        moment(startDate).add(1, 'day').format('YYYY-MM-DD') + ' 00:00';
      endDate = moment(endDate).add(1, 'day').format('YYYY-MM-DD') + ' 23:59';
      periodTitle = dayFormatAbbreviation(
        moment(startDate).format('ddd - DD.MM.YYYY')
      );
    }
    if (
      period === 'week' ||
      (prevSelectedPeriod === 'week' && !isDateChanged && period === 'custom')
    ) {
      startDate =
        moment(startDate).add(1, 'week').format('YYYY-MM-DD') + ' 00:00';
      endDate = moment(endDate).add(1, 'week').format('YYYY-MM-DD') + ' 23:59';
      const currentWeekNumber = moment(startDate).isoWeek();
      periodTitle = 'Uke nr' + ' ' + currentWeekNumber;
    }

    if (
      period === 'month' ||
      (prevSelectedPeriod === 'month' && !isDateChanged && period === 'custom')
    ) {
      startDate =
        moment(startDate).add(1, 'month').format('YYYY-MM-DD') + ' 00:00';
      endDate =
        period === 'month'
          ? moment(endDate)
              .add(1, 'month')
              .endOf('month')
              .format('YYYY-MM-DD') + ' 23:59'
          : moment(endDate).add(1, 'month').format('YYYY-MM-DD') + ' 23:59';
      periodTitle = moment(startDate).format('MMMM');
    }

    if (
      period === 'year' ||
      (prevSelectedPeriod === 'year' && !isDateChanged && period === 'custom')
    ) {
      startDate =
        moment(startDate).add(1, 'year').format('YYYY-MM-DD') + ' 00:00';
      endDate = moment(endDate).add(1, 'year').format('YYYY-MM-DD') + ' 23:59';
      periodTitle = moment(startDate).format('YYYY');
    }

    if (period === 'custom' && prevSelectedPeriod === 'custom') {
      let previousStartDate = moment(startDate);
      let previousEndDate = moment(endDate);

      startDate = moment(endDate).add(1, 'day').format('YYYY-MM-DD') + ' 00:00';

      durationOfstartAndEndDate = previousEndDate.diff(
        previousStartDate,
        'days'
      );

      endDate =
        moment(startDate)
          .add(durationOfstartAndEndDate, 'days')
          .format('YYYY-MM-DD') + ' 23:59';
      periodTitle =
        moment(startDate).format('DD-MM-YYYY') +
        ' : ' +
        moment(endDate).format('DD-MM-YYYY');
    }

    $('#start-date').val(startDate);
    $('#end-date').val(endDate);
    $('#period-title').text(periodTitle);
    callback(
      startDate,
      endDate,
      period,
      supplierId,
      productGroupUniqueId,
      locationId,
      userId,
      platform,
      customPeriod,
      topProductGroupUniqueId,
      customerId,
      compareBy,
      productId,
      vatCode,
      paymentMethod,
      productCategoryId
    );
    if (compareBy && compareBy == 'day-compare') {
      let $compare = $('#compare');
      let dayCompareOption = $compare.find("option[value='day-compare']");

      if (dayCompareOption.length) {
        dayCompareOption.text(
          `i dag / forrige ${getPeriodTranslation(compareBy, startDate)}`
        );
        $compare.val('day-compare');
        $compare.trigger('change.select2');
        $compare.select2('destroy');
        $compare.select2({ theme: 'bootstrap4' });
      }
    }
  });
}

function handleCompareByChange(callback) {
  $(document).on('change', '#compare', function (e) {
    e.preventDefault();
    compareBy = $(this).val();

    if (compareBy === 'day-compare') {
      period = 'day';
    } else if (compareBy === 'week-compare') {
      period = 'week';
    } else if (compareBy === 'month-compare') {
      period = 'month';
    } else {
      compareBy = null;
    }
    $(`.period-button[data-value='${period}']`).trigger('click');
  });
}

function displayGraphDynamically(durationOfstartAndEndDate) {
  if (isMobile) {
    if (durationOfstartAndEndDate <= 2 && period != 'custom') {
      customPeriod = 'time';
    } else if (durationOfstartAndEndDate <= 7) {
      customPeriod = 'day';
      $("#custom-period option[value='day']").prop('disabled', false);
      $("#custom-period option[value='day']").prop('selected', true);
      $("#custom-period option[value='week']").prop('disabled', false);
      $("#custom-period option[value='time']").prop('disabled', true);
      $("#custom-period option[value='time']").addClass('disabledOption');
      $("#custom-period option[value='day']").removeClass('disabledOption');
      $("#custom-period option[value='week']").removeClass('disabledOption');
      $('.custom-day-container').removeClass('d-none');
    } else if (
      durationOfstartAndEndDate >= 8 &&
      durationOfstartAndEndDate < 49
    ) {
      //week
      customPeriod = 'week';
      $(`#custom-period option[value="week"]`).prop('selected', true);
      $("#custom-period option[value='week']").prop('disabled', false);
      $("#custom-period option[value='time']").prop('disabled', true);
      $("#custom-period option[value='day']").prop('disabled', true);
      $("#custom-period option[value='time']").addClass('disabledOption');
      $("#custom-period option[value='day']").addClass('disabledOption');
      $("#custom-period option[value='week']").removeClass('disabledOption');
      $('.custom-day-container').addClass('d-none');
    } else {
      //month
      customPeriod = 'month';
      $(`#custom-period option[value="week"]`).prop('selected', false);
      $(`#custom-period option[value="month"]`).prop('selected', true);
      $("#custom-period option[value='time']").prop('disabled', true);
      $("#custom-period option[value='day']").prop('disabled', true);
      $("#custom-period option[value='week']").prop('disabled', true);
      $("#custom-period option[value='time']").addClass('disabledOption');
      $("#custom-period option[value='day']").addClass('disabledOption');
      $("#custom-period option[value='week']").addClass('disabledOption');
      $('.custom-day-container').addClass('d-none');
    }
  } else if (isTablet) {
    if (durationOfstartAndEndDate <= 2 && period != 'custom') {
      customPeriod = 'time';
    } else if (durationOfstartAndEndDate <= 180) {
      //day
      customPeriod = 'day';
      $("#custom-period option[value='day']").prop('disabled', false);
      $("#custom-period option[value='day']").prop('selected', true);
      $("#custom-period option[value='week']").prop('disabled', false);
      $("#custom-period option[value='time']").prop('disabled', true);
      $("#custom-period option[value='time']").addClass('disabledOption');
      $("#custom-period option[value='day']").removeClass('disabledOption');
      $("#custom-period option[value='week']").removeClass('disabledOption');
      $('.custom-day-container').removeClass('d-none');
    } else if (
      durationOfstartAndEndDate >= 181 &&
      durationOfstartAndEndDate < 365
    ) {
      //week
      customPeriod = 'week';
      $(`#custom-period option[value="week"]`).prop('selected', true);
      $("#custom-period option[value='week']").prop('disabled', false);
      $("#custom-period option[value='time']").prop('disabled', true);
      $("#custom-period option[value='day']").prop('disabled', true);
      $("#custom-period option[value='time']").addClass('disabledOption');
      $("#custom-period option[value='day']").addClass('disabledOption');
      $("#custom-period option[value='week']").removeClass('disabledOption');
      $('.custom-day-container').addClass('d-none');
    } else {
      //month
      customPeriod = 'month';
      $(`#custom-period option[value="week"]`).prop('selected', false);
      $(`#custom-period option[value="month"]`).prop('selected', true);
      $("#custom-period option[value='time']").prop('disabled', true);
      $("#custom-period option[value='day']").prop('disabled', true);
      $("#custom-period option[value='week']").prop('disabled', true);
      $("#custom-period option[value='time']").addClass('disabledOption');
      $("#custom-period option[value='day']").addClass('disabledOption');
      $("#custom-period option[value='week']").addClass('disabledOption');
      $('.custom-day-container').addClass('d-none');
    }
  } else {
    if (durationOfstartAndEndDate <= 2 && period != 'custom') {
      customPeriod = 'time';
    } else if (durationOfstartAndEndDate <= 180) {
      //day
      customPeriod = 'day';
      $("#custom-period option[value='day']").prop('disabled', false);
      $("#custom-period option[value='day']").prop('selected', true);
      $("#custom-period option[value='week']").prop('disabled', false);
      $("#custom-period option[value='time']").prop('disabled', true);
      $("#custom-period option[value='time']").addClass('disabledOption');
      $("#custom-period option[value='day']").removeClass('disabledOption');
      $("#custom-period option[value='week']").removeClass('disabledOption');
      $('.custom-day-container').removeClass('d-none');
    } else if (
      durationOfstartAndEndDate >= 181 &&
      durationOfstartAndEndDate < 365
    ) {
      //week
      customPeriod = 'week';
      $(`#custom-period option[value="week"]`).prop('selected', true);
      $("#custom-period option[value='week']").prop('disabled', false);
      $("#custom-period option[value='time']").prop('disabled', true);
      $("#custom-period option[value='day']").prop('disabled', true);
      $("#custom-period option[value='time']").addClass('disabledOption');
      $("#custom-period option[value='day']").addClass('disabledOption');
      $("#custom-period option[value='week']").removeClass('disabledOption');
      $('.custom-day-container').addClass('d-none');
    } else {
      //month
      customPeriod = 'month';
      $(`#custom-period option[value="week"]`).prop('selected', false);
      $(`#custom-period option[value="month"]`).prop('selected', true);
      $("#custom-period option[value='time']").prop('disabled', true);
      $("#custom-period option[value='day']").prop('disabled', true);
      $("#custom-period option[value='week']").prop('disabled', true);
      $("#custom-period option[value='time']").addClass('disabledOption');
      $("#custom-period option[value='day']").addClass('disabledOption');
      $("#custom-period option[value='week']").addClass('disabledOption');
      $('.custom-day-container').addClass('d-none');
    }
  }
}

function handleDateAndTimeChange(callback) {
  $('#start-date').datetimepicker({
    dateFormat: 'yy-mm-dd',
    timeFormat: 'HH:mm',
    showButtonPanel: true,
    regional: ['no', 'NO'],
    yearRange: '1900:2100', // Adjust the year range
    onClose: function () {
      if (startDate !== $(this).val()) {
        handleStartDateChange(callback);
      }
    },
  });

  // Initialize the Datepicker for end-date
  $('#end-date').datetimepicker({
    dateFormat: 'yy-mm-dd',
    timeFormat: 'HH:mm',
    showButtonPanel: true,
    yearRange: '1900:2100', // Adjust the year range
    onClose: function () {
      if (endDate !== $(this).val()) {
        handleEndDateChange(callback);
      }
    },
  });
}

function toggleCustomDatePicker() {
  let customDatePicker = $('.custom-date-picker');

  if (period === 'custom') {
    customDatePicker.show();
  } else {
    customDatePicker.hide();
  }
}

function getLegendTexts(compareBy, startDate) {
  const start = moment(startDate);
  let legendText = '';
  let previousLegendText = '';

  switch (compareBy) {
    case 'day-compare':
      legendText = start.format('dddd');
      previousLegendText = start.clone().subtract(7, 'days').format('dddd');
      break;

    case 'week-compare':
      legendText = `Uke ${start.isoWeek()}`;
      previousLegendText = `Uke ${start.clone().subtract(1, 'weeks').isoWeek()}`;
      break;

    case 'month-compare':
      legendText = start.format('MMMM');
      previousLegendText = start.clone().subtract(1, 'months').format('MMMM');
      break;

    default:
      legendText = 'Nåværende periode';
      previousLegendText = 'Tidligere periode';
      break;
  }

  return { legendText, previousLegendText };
}

$(document).ready(function () {
  $(
    'select[name=supplier-id],select[name=product-group-id],select[name=user-id],select[name=platform],select[name=top-product-group-id],select[name=customer-id],select[name=compare],select[name=product-id],select[name=product-group-id],select[name=vatCode],select[name=paymentMethod],select[name=vat_code],select[name=payment_method],select[name=location_id]'
  ).select2({
    theme: 'bootstrap4',
  });

  const locationTree = $('#statistic-location-tree');
  if (locationTree.length) {
    $('#content-body').addClass('statistic-page-with-sidebar');

    const locationSidebar = $('#statistic-location-sidebar');
    const locationToggle = $('.statistic-location-toggle');
    const locationBackdrop = $('.statistic-location-backdrop');
    const compactSidebarQuery = window.matchMedia('(max-width: 1024px)');

    function setLocationDrawerOpen(open) {
      const drawerIsOpen = compactSidebarQuery.matches && open;
      locationSidebar.toggleClass('is-open', drawerIsOpen);
      locationToggle.attr('aria-expanded', String(drawerIsOpen));
      locationSidebar.attr(
        'aria-hidden',
        String(compactSidebarQuery.matches && !drawerIsOpen)
      );
      locationBackdrop.attr('aria-hidden', String(!drawerIsOpen));
      $('body').toggleClass('statistic-location-drawer-open', drawerIsOpen);
    }

    locationToggle.on('click.statistic-location-drawer', function () {
      setLocationDrawerOpen(true);
    });
    $('.statistic-location-close, .statistic-location-backdrop').on(
      'click.statistic-location-drawer',
      function () {
        setLocationDrawerOpen(false);
      }
    );
    $(document).on('keydown.statistic-location-drawer', function (event) {
      if (event.key === 'Escape') {
        setLocationDrawerOpen(false);
      }
    });

    const resetLocationDrawer = function () {
      setLocationDrawerOpen(false);
    };
    if (compactSidebarQuery.addEventListener) {
      compactSidebarQuery.addEventListener('change', resetLocationDrawer);
    } else {
      compactSidebarQuery.addListener(resetLocationDrawer);
    }
    setLocationDrawerOpen(false);

    let isUpdatingTree = false;
    let selectionBeforePointer = [];
    let lastPointerNodeId = null;
    let lastPointerTime = 0;
    let lastTouchSelectionTime = 0;

    function getAvailableScope(tree) {
      return tree.get_json('#', { flat: true }).reduce(function (scope, node) {
        const nodeScope = node.li_attr['data-scope'];
        if (nodeScope) {
          scope[nodeScope] = node.id;
        }
        return scope;
      }, {});
    }

    function syncLocationFilter(scope, triggerChange) {
      const selectedLocations = scope.includes('all')
        ? ['all']
        : [...new Set(scope.map((item) => item.split(':')[1]))];
      const locationSelect = $('#location-id');
      locationSelect.selectpicker('val', selectedLocations);
      if (triggerChange) {
        locationSelect.trigger('change');
      }
      saveStatisticFilters(scope);
    }

    function replaceTreeSelection(tree, nodeIds, triggerChange) {
      isUpdatingTree = true;
      tree.deselect_all(true);
      tree.select_node(nodeIds, true, true);
      isUpdatingTree = false;
      tree.redraw(true);
      syncLocationFilter(getSelectedStatisticScope(tree), triggerChange);
    }

    function toggleNodeAdditively(tree, node, previousSelection) {
      const selectedNodes = new Set(previousSelection);
      const nodeScope = node.li_attr['data-scope'];
      if (nodeScope === 'all') {
        replaceTreeSelection(tree, ['statistic-scope-all'], true);
        return;
      }

      selectedNodes.delete('statistic-scope-all');
      if (selectedNodes.has(node.id)) {
        selectedNodes.delete(node.id);
      } else {
        selectedNodes.add(node.id);
      }
      if (!selectedNodes.size) {
        selectedNodes.add('statistic-scope-all');
      }
      replaceTreeSelection(tree, [...selectedNodes], true);
    }

    locationTree
      .on('click.statistic-tree-location', '.jstree-anchor', function (event) {
        if (event.originalEvent.detail > 1) {
          return;
        }
        const tree = locationTree.jstree(true);
        const node = tree.get_node(this);
        if (node.type === 'location') {
          tree.toggle_node(node);
        }
      })
      .on('ready.jstree', function () {
        const tree = locationTree.jstree(true);
        const availableScope = getAvailableScope(tree);
        const requestedScope =
          getSavedStatisticFilters().scope || getDefaultStatisticScope();
        const selectedScope = normalizeStatisticScope(
          requestedScope,
          Object.keys(availableScope)
        );
        const selectedNodes = selectedScope.map(
          (scope) => availableScope[scope]
        );
        selectedNodes.forEach(function (nodeId) {
          const parentNodeId = tree.get_parent(nodeId);
          if (parentNodeId && parentNodeId !== '#') {
            tree.open_node(parentNodeId);
          }
        });
        replaceTreeSelection(tree, selectedNodes, false);
      })
      .on('changed.jstree', function (event, data) {
        if (isUpdatingTree) {
          return;
        }

        const tree = data.instance;
        const changedScope = data.node?.li_attr['data-scope'];
        isUpdatingTree = true;
        if (changedScope === 'all' && data.action === 'select_node') {
          tree.deselect_all(true);
          tree.select_node('statistic-scope-all', true, true);
        } else if (changedScope !== 'all') {
          tree.deselect_node('statistic-scope-all', true);
        }

        let selectedScope = getSelectedStatisticScope(tree);
        if (!selectedScope.length) {
          tree.select_node('statistic-scope-all', true, true);
          selectedScope = ['all'];
        }
        isUpdatingTree = false;

        syncLocationFilter(selectedScope, true);
      })
      .on('pointerdown.statistic-tree', '.jstree-anchor', function (event) {
        const tree = locationTree.jstree(true);
        const node = tree.get_node(this);
        const pointerType = event.originalEvent.pointerType;
        const now = Date.now();
        const isRepeatedPointer =
          node.id === lastPointerNodeId && now - lastPointerTime < 500;

        if (
          (pointerType === 'touch' || pointerType === 'pen') &&
          isRepeatedPointer
        ) {
          event.preventDefault();
          toggleNodeAdditively(tree, node, selectionBeforePointer);
          lastPointerNodeId = null;
          lastPointerTime = 0;
          lastTouchSelectionTime = now;
          return;
        }

        if (!isRepeatedPointer) {
          selectionBeforePointer = tree.get_selected();
        }
        lastPointerNodeId = node.id;
        lastPointerTime = now;
      })
      .on('dblclick.statistic-tree', '.jstree-anchor', function (event) {
        event.preventDefault();
        if (Date.now() - lastTouchSelectionTime < 700) {
          return;
        }
        const tree = locationTree.jstree(true);
        toggleNodeAdditively(
          tree,
          tree.get_node(this),
          selectionBeforePointer
        );
      })
      .jstree({
        core: {
          multiple: true,
          dblclick_toggle: false,
          themes: { responsive: false, dots: true },
        },
        types: {
          all: { icon: 'jstree-folder' },
          location: { icon: 'jstree-folder' },
          device: { icon: 'jstree-folder' },
        },
        plugins: ['changed', 'types', 'wholerow'],
      });
  }

  $(document).on('change', '#event-statistic-form :input', function () {
    saveStatisticFilters(getStatisticScope());
  });

  $(document).on('click', '.statistic-tab-link', function () {
    saveStatisticFilters(getStatisticScope());
    const targetUrl = new URL(this.href, window.location.origin);
    const periodFilters = {
      filter_by: period,
      custom_period: customPeriod,
      prev_selected_period: prevSelectedPeriod,
      start_date: startDate,
      end_date: endDate,
    };
    Object.keys(periodFilters).forEach(function (key) {
      if (periodFilters[key] !== null && periodFilters[key] !== '') {
        targetUrl.searchParams.set(key, periodFilters[key]);
      }
    });
    this.href = targetUrl.toString();
  });

  const activeTab = $('#pills-tab .active').get(0);
  if (activeTab) {
    activeTab.scrollIntoView({
      block: 'nearest',
      inline: 'center',
    });
  }
});

$(document).on('click', '#period-title', function () {
  console.log('clicked');

  $('.period-button[data-value="custom"]').trigger('click');
});
